import React, { useEffect, useState } from "react";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import ErrorMsg from "../../components/form/errorMsg";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { termsConditionsview } from "../../redux/actions/settingAction";
import { useDispatch } from "react-redux";

const TermsConditionView = () => {
  const dispatch = useDispatch();
  const [termsConditionData, setTermsConditionData] = useState("");

  const initialValues = {
    text: termsConditionData?.terms,
  };

  const validationSchema = Yup.object().shape({
    text: Yup.string().required("Required"),
  });

  const modules = {
    toolbar: [
      [{ header: "1" }, { header: "2" }],
      ["bold", "italic", "underline"],
      [{ list: "bullet" }],
      [{ align: "" }],
    ],
  };

  const onSubmit = (values) => {
    console.log(values);
  };

  useEffect(() => {
    dispatch(termsConditionsview(onViewSuccess, onViewError));
  }, []);

  const onViewSuccess = (data) => {
    console.log(data);
    setTermsConditionData(data.data.data);
  };

  const onViewError = (err) => {
    console.log(err);
  };

  return (
    <>
      <div className="p-4">
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
          enableReinitialize={true}
        >
          {({ setFieldValue, values }) => (
            <Form className="">
              <div className="faq-form-width ms-4 my-4 p-4">
                <div className="mb-3">
                  <span className="fs_20 fw_400">Terms and Conditions</span>
                </div>
                <div className="">
                  <Field name="text">
                    {({ field }) => (
                      <ReactQuill
                        value={field.value}
                        onChange={field.onChange(field.name)}
                        modules={modules}
                        style={{
                          
                          height: "50vh",
      
                          width:"100%"
                        }}
                        className={"quill"}
                        placeholder={"Enter Terms and Conditions's here"}
                      />
                    )}
                  </Field>
                </div>
                <ErrorMsg name={"text"} />
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </>
  );
};

export default TermsConditionView;
